import axios from 'axios'
import { loadAbort } from 'utilities'

export type KycStatus =
  | 'INITIATED'
  | 'IN_PROGRESS'
  | 'APPROVED'
  | 'DECLINED'
  | 'IN_REVIEW'
  | 'ABANDONED'
  | 'EXPIRED'

export interface SessionStatusResponse {
  status: KycStatus
}

export const getKycSessionStatus = (verificationSessionId: string) => {
  const controller = loadAbort()
  const url = `${
    process.env.REACT_APP_BASE_URL
  }/rfx/kyc/session-status/?verificationSessionId=${encodeURIComponent(
    verificationSessionId,
  )}`

  return {
    call: axios.get<SessionStatusResponse>(url, {
      signal: controller.signal,
      headers: {
        Accept: 'application/json',
      },
    }),
    controller,
  }
}
